import "./Capsule.css"


function Capsule(prop) {

return (
        <div className="Capsule">
            <p>{prop.value}</p>
        </div>

    );
}

export default Capsule;